import PropTypes from 'prop-types';
import React from 'react';
import styled, { keyframes } from 'styled-components';

const Loading = ({ text, color, size, ...props }) => (
  <Root mainColor={color} {...props}>
    <Text>{text}</Text>
    <FloatingCircles mainColor={color} size={size}>
      <CircleOne />
      <CircleTwo />
      <CircleThree />
      <CircleFour />
      <CircleFive />
      <CircleSix />
      <CircleSeven />
      <CircleEight />
    </FloatingCircles>
  </Root>
);

Loading.propTypes = {
  text: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeColor = keyframes`
	0%{
		background-color: transparent;
	}

	100%{
		/* background-color: #9c9c9c; */
    background-color:${({ mainColor }) => mainColor};
	}
`;

const Root = styled.div`
  display: flex;
  align-items: center;
  font-family: inherit;
  font-size: 14px;
  font-style: italic;
  font-weight: 400;
  line-height: 20px;
  /* color: #9c9c9c; */
  color: ${({ mainColor }) => mainColor};
  animation: ${fadeIn} 0.5s linear;
`;

const Text = styled.p`
  margin: 0 2px 0 0;
`;

const FloatingCircles = styled.div`
  position: relative;
  /* width: 22px;
  height: 22px; */
  width: ${({ size }) => `${size * 5.5}px`};
  height: ${({ size }) => `${size * 5.5}px`};
  transform: scale(0.7);
  div {
    position: absolute;
    /* background-color: #9c9c9c; */
    background-color: ${({ mainColor }) => mainColor};
    /* width: 4px;
    height: 4px; */
    width: ${({ size }) => `${size}px`};
    height: ${({ size }) => `${size}px`};
    border-radius: 100%;
    animation-name: ${fadeColor};
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
    animation-direction: normal;
  }
`;

const CircleOne = styled.div`
  left: 0;
  top: 40.8%;
  animation-delay: 0.45s;
`;

const CircleTwo = styled.div`
  left: 12%;
  top: 12%;
  animation-delay: 0.6s;
`;

const CircleThree = styled.div`
  left: 40.8%;
  top: 0;
  animation-delay: 0.75s;
`;

const CircleFour = styled.div`
  right: 12%;
  top: 12%;
  animation-delay: 0.9s;
`;

const CircleFive = styled.div`
  right: 0;
  top: 40.8%;
  animation-delay: 1.05s;
`;

const CircleSix = styled.div`
  right: 12%;
  bottom: 12%;
  animation-delay: 1.2s;
`;

const CircleSeven = styled.div`
  left: 40.8%;
  bottom: 0;
  animation-delay: 1.35s;
`;

const CircleEight = styled.div`
  left: 12%;
  bottom: 12%;
  animation-delay: 1.5s;
`;

export default Loading;
